import {
  EEquipmentPhysicalTypeCategory,
} from '@/types/equipment.ts';

const category: Record<EEquipmentPhysicalTypeCategory, string> = {
  [EEquipmentPhysicalTypeCategory.BATCH_FURNACE]: 'Chargenöfen',
  [EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE]: 'Halbkontinuierliche Öfen',
  [EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE]: 'Kontinuierliche Öfen',
  [EEquipmentPhysicalTypeCategory.STORAGE]: 'Lager',
};

export default {
  placeholder: 'Wähle die Bauart der Anlage',
  category,
};
